import { render } from "./QuyDinh.vue?vue&type=template&id=9276948e"
import script from "./QuyDinh.vue?vue&type=script&lang=js"
export * from "./QuyDinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__